import {
  frequencyOptions,
  timeDimensionOptions,
  timeGroupingTypeOptions,
  targetOptions,
  aggregatorOptions,
  DiagramTypes,
} from './constants';

export const chartConfigurations = {
  ageDistribution: {
    getEventStats: {
      targets: [
        {
          column: targetOptions.event_id.value,
          aggregator: aggregatorOptions.count.value,
        },
        {
          column: targetOptions.age.value,
          aggregator: 'group_by',
        },
      ],
      group_by: {
        type: null,
        count: '',
        timeDimension: null,
        frequency: null,
      },
      filters: [],
      period: [],
    },
    getTemplateStats: {
      name: '',
      diagramType: DiagramTypes.BAR,
    },
  },
  attendanceByGender: {
    getEventStats: {
      targets: [
        {
          column: targetOptions.event_id.value,
          aggregator: aggregatorOptions.count.value,
        },
        {
          column: targetOptions.gender.value,
          aggregator: 'group_by',
        },
      ],
      group_by: {
        type: timeGroupingTypeOptions?.interval.value,
        count: '1',
        timeDimension: timeDimensionOptions?.d.value,
        frequency: null,
      },
      filters: [],
      period: [],
    },
    getTemplateStats: {
      name: '',
      diagramType: DiagramTypes.STACK,
    },
  },
  genderDistribution: {
    getEventStats: {
      targets: [
        {
          column: targetOptions.event_id.value,
          aggregator: aggregatorOptions.count.value,
        },
        {
          column: targetOptions.gender.value,
          aggregator: 'group_by',
        },
      ],
      group_by: {
        type: timeGroupingTypeOptions?.frequency.value,
        frequency: frequencyOptions?.dayOfWeek.value,
        count: '',
        timeDimension: null,
      },
      filters: [],
      period: [],
    },
    getTemplateStats: {
      name: '',
      diagramType: DiagramTypes.RADAR,
    },
  },
  genderRatio: {
    getEventStats: {
      targets: [
        {
          column: targetOptions.event_id.value,
          aggregator: aggregatorOptions.count.value,
        },
        {
          column: targetOptions.gender.value,
          aggregator: 'group_by',
        },
      ],
      group_by: {
        type: null,
        count: '',
        timeDimension: null,
        frequency: null,
      },
      filters: [],
      period: [],
    },
    getTemplateStats: {
      name: '',
      diagramType: DiagramTypes.DOUGHNUT,
    },
  },
  emotionDistribution: {
    getEventStats: {
      targets: [
        {
          column: targetOptions.event_id.value,
          aggregator: aggregatorOptions.count.value,
        },
        {
          column: targetOptions.emotion.value,
          aggregator: 'group_by',
        },
      ],
      group_by: {
        type: null,
        count: '',
        timeDimension: null,
        frequency: null,
      },
      filters: [],
      period: [],
    },
    getTemplateStats: {
      name: '',
      diagramType: DiagramTypes.PIE,
    },
  },
  averageAgeByGender: {
    getEventStats: {
      targets: [
        {
          column: targetOptions.age.value,
          aggregator: aggregatorOptions.avg.value,
        },
        {
          column: targetOptions.gender.value,
          aggregator: 'group_by',
        },
      ],
      group_by: {
        type: timeGroupingTypeOptions?.interval.value,
        count: 1,
        timeDimension: timeDimensionOptions?.M.value,
        frequency: null,
      },
      filters: [],
      period: [],
    },
    getTemplateStats: {
      name: '',
      diagramType: DiagramTypes.LINE,
    },
  },
};
